/* eslint-disable no-tabs */
import gql from 'graphql-tag';

export const fetchOrganizationUsers = gql`query SearchUsers($limit: Int, $offset: Int) {
  user_aggregate {
    aggregate {
      count
    }
  }
  user(limit: $limit, offset: $offset) {
    id
    user_name
    email
    first_name
    last_name
    activated_at
    created_at
    locked_at
    organizations: organization_users {
      organization_id
      organization {
        name
      }
    }
  }
}`;

// eslint-disable-next-line
export const fetchCatalogItemByCatalogDefault = gql `query SearchCatalogItems(
  $limit: Int!, 
  $offset: Int!, 
  $catalogId: uuid!,
  $price_gte: numeric,
  $price_lte: numeric,
  $keyword: String) {
  search_item_aggregate(
    where: {
      _and: {
        catalog_id: { _eq: $catalogId }
        catalog: { is_active: { _eq: true } }
      }
    }
    args: { search: $keyword }
  ) {
    aggregate {
      count
    }
  }
  search_item(
    where: {
      _and: {
        catalog_id: { _eq: $catalogId }
        catalog: { is_active: { _eq: true } }
      }
    }
    args: { search: $keyword }
    limit: $limit
    offset: $offset
  ) {
    id
    sku
    name
    description
    currency
    price
    uom
    manufacturer
    manufacturer_partnumber
    published_at
    has_stock
    is_obsolete
    is_active
    technical_specification
    image
    taxonomy_category {
      mdm_code
      mdm_name
    }
  }
}
`;

// eslint-disable-next-line
export const fetchCatalogItemByCatalog = gql `query SearchCatalogItems(
    $limit: Int!, 
    $offset: Int!, 
    $catalogId: uuid!,
    $published_at_is_null: Boolean,
    $price_gte: numeric,
  	$price_lte: numeric,
    $keyword: String) {
    search_item_aggregate(
      where: {
        _and: {
          catalog_id: { _eq: $catalogId }
          catalog: { is_active: { _eq: true } },
          published_at: {_is_null: $published_at_is_null},
          price: { _gte: $price_gte, _lte: $price_lte}
        }
      }
      args: { search: $keyword }
    ) {
      aggregate {
        count
      }
    }
    search_item(
      where: {
        _and: {
          catalog_id: { _eq: $catalogId }
          catalog: { is_active: { _eq: true } },
          published_at: {_is_null: $published_at_is_null}
          price: { _gte: $price_gte, _lte: $price_lte}
        }
      }
      args: { search: $keyword }
      limit: $limit
      offset: $offset
    ) {
      id
      sku
      name
      description
      currency
      price
      uom
      manufacturer
      manufacturer_partnumber
      published_at
      has_stock
      is_obsolete
      is_active
      technical_specification
      image
      taxonomy_category {
        mdm_code
        mdm_name
      }
    }
  }
`;

export const getOrganizationByPkQuery = gql `
  query getOrganizationByPk($organizationId: uuid!) {
    organization_by_pk(id: $organizationId) {
      id
      name
      description
      website
      tax_id
      contact_name
      contact_email
      country
      city
      address
      created_date
      last_billing
    }
  }
`;


export const emailOrganizationContactCount = gql `query	OrganizationContactExists($organizationId: uuid, $email: String!) {
  organization_contact_aggregate(where: { organization_id: {_eq: $organizationId} email: { _eq: $email }}) {
    aggregate {
      count
    }
  }
}`;

export const searchOrganizations = gql `query searchOrganizations($limit: Int!, $offset: Int!,$keyword: String) {
    organization_aggregate(where: {_or: [{name: {_like: $keyword}}, {tax_id: {_like: $keyword}}]}) {
      aggregate {
        count
      }
    }
    organization(
      where: {
        _or: [
          {name: {_like: $keyword}},
          {tax_id: {_like: $keyword}}
        ]
      },
      limit: $limit
      offset: $offset
    ) {
        id
        name
        tax_id
        created_at
    }
}`;



// WEBPACK FOOTER //
// ./src/store/graphql/queries/_admin-catalog.js